import Vue from 'vue'
import Component from 'vue-class-component'
import authStore from '@/store/auth/auth-store'
import Feed from './feed/Feed.vue'
import AuthHeader from '@/components/AuthHeader'
import FeedbackAdd from '@/components/feedback/FeedbackAdd'
import mainStore from '@/store/main/main-store'
import NonAuthHeader from '@/components/NonAuthHeader'
import About from '@/components/About'
import LoadingIndicator from '@/components/LoadingIndicator'

@Component({
  name: 'auth-layout',
  components: {
    'loading-indicator': LoadingIndicator,
    'about': About,
    'feedback': FeedbackAdd,
    'feed': Feed,
    'auth-header': AuthHeader,
    'non-auth-header': NonAuthHeader
  }
})
export default class MainLayout extends Vue {
  mounted (): void {
    this.authenticate()

    this.$store.subscribe((mutation, state) => {
      console.log('Authenticate mutation: type = %j', mutation.type)
      if (mutation.type === 'auth/setNotAuthenticated') {
        if (this.isAuthRequired) {
          if(mainStore.forceLogin) {
            this.login()
          } else {
/* 
            this.$router.push ({
              path: '/about'
            })
*/            
          }
        }
      }
    })
  }

  get currentPage () { return mainStore.component }

  get isAuthenticated () { return authStore.isAuthenticated }

  get isAuthRequired () { return mainStore.isAuthRequired }

  get isInitialized () { return authStore.isInitialized }

  get component () { return mainStore.component }

  protected authenticate (): void {
    authStore.dispatchAuthenticate()
  }

  protected login (): void {
    authStore.dispatchLogin()
  }

}
